import React from 'react'
import UserRegisterPage from '../components/user/user-register'

export default function UserRegister() {
    return (
        <div className='admin'>
            <UserRegisterPage />
        </div>
    )
}
